import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button, useMediaQuery} from "@mui/material";
import { useNavigate } from "react-router-dom";
import GridViewIcon from "@mui/icons-material/GridView";
import { useParams } from "react-router-dom";
import VideoPlayer from "../components/VideoPlayer";

let profileInfo = require("../artistProfileInfo.js");

function ArtistProfileMobile() {
    let params = useParams();
    let artistsData = profileInfo.getArtistProfileData();
    let artist = artistsData[params.artist];
    let [exiting, setExiting] = useState(false);
    let [profileVideoProgress, setProfileVideoProgress] = useState(0.0);
    const finalVideoProgress = useRef(profileVideoProgress);

    let navigate = useNavigate();

    const landscapeOrientation = useMediaQuery('(orientation:landscape)');
    
    useEffect(() => {
        window.gtag('event', 'page_view', {
            page_title: `${artist.name} Profile`,
            page_location: window.location.href,
            gallery_device: false,
            send_to: 'G-PC1LP4S0D0'
        });
    },[artist.name])
    
    useEffect(() => {
        return () => {
            finalVideoProgress.current = profileVideoProgress;
        }
    }, [profileVideoProgress])

    useEffect(() => {
        if (exiting) {
            navigate("/artists", { state: "from profile" });
            return () => {
                window.gtag('event', 'video_view', {
                    video_title: `${artist.name}`,
                    video_completion: finalVideoProgress.current,
                    gallery_device: false,
                    send_to: 'G-PC1LP4S0D0'
                })
            }
        }
    }, [exiting, navigate, artist.name]);



    return (
        <Box
            role="region"
            aria-label={`${artist.name} profile information and video.`}
            sx={{
                width: landscapeOrientation ? "90vw" : "100vw",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "secondary.main",
                margin: "0 auto",

            }}
        > 
            <Box
                sx={{
                    marginTop: "40px",
                    marginBottom: "30px",
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "primary.main",
                        height: "40px",
                        width: "44.39vw",
                        minWidth: "170px",
                        borderRadius: "20px",
                        color: "text.darker",
                        fontSize: "15px",
                        lineHeight: "18px",
                        letterSpacing: "1.5pt",
                        fontFamily: "GT Eesti Display Bold",
                        
                    }}
                    onClick={() => {
                        setExiting(true);
                    }}
                >
                    
                    <GridViewIcon
                        style={{ fontSize: "25px" }}
                        sx={{
                            marginRight: "4%",
                        }}
                    />
                    All Artists
                </Button>
            </Box>
            <Box role="group" aria-label="Artist image and quote">
                <Typography
                    component="h1"
                    sx={{
                        fontFamily: "GT Eesti Display Bold",
                        fontSize: "30px",
                        lineHeight: "35px",
                        letterSpacing: "0.6pt",
                        height: "auto",
                        color: "text.contrast",
                        minWidth: "200px",
                        textAlign: "center"
                    }}
                >
                    {artist.name}
                </Typography>
                <Box
                    role="img"
                    aria-label={`${artist.name} image`}
                    sx={{
                        background: `url(${artist.mobileImage}) no-repeat`,
                        backgroundSize: "cover",
                        width: landscapeOrientation ? "70vw" : "90vw",
                        minWidth: "200px",
                        aspectRatio: "388/460",
                        marginTop: "15px"

                    }}
                        >
                </Box>
                <Typography
                    sx={{
                        fontFamily: "GT Eesti Display Regular Italic",
                        fontSize: "18px",
                        lineHeight: "28px",
                        letterSpacing: ".36pt",
                        color: "text.contrast",
                        width: landscapeOrientation ? "70vw" : "90vw",
                        minWidth: "200px",
                        marginTop: "20px",
                    }}
                >
                        {artist.quote}
                </Typography>
            </Box>
            <Box role="region" aria-label="Profile Video">
                <VideoPlayer
                    vidStyle={{
                        width: landscapeOrientation ? "70vw" : "90vw",
                        minWidth: "200px",
                        marginTop: "20px"
                    }}
                    vidSrc={artist.videos.mobile}
                    controls={false}
                    setExiting={setExiting}
                    exitDelay={false}
                    mobile={true}
                    setProfileVideoProgress={setProfileVideoProgress}
                />
            </Box>
        </Box>
    );
}

export default ArtistProfileMobile;